import { ref, watchEffect } from 'vue'
import axios from "./axios";
import router from "../router";

export default function useApiResource(options) {
    const resource = ref(null)
    const resourceLoading = ref(false)
    const resourcePosting = ref(false)
    const apiError = ref(false)
    const apiStatus = ref(null)

    const getResource = async () => {
        //console.log('getResource ', options)
        resource.value = []
        if(!options.publicId){
            resourceLoading.value = false

            return
        }
        resourceLoading.value = true
        await axios.get(options.resourcePath + options.publicId, {params: options.resourceParams}).then(data => {
            resource.value = data.data
            resourceLoading.value = false
        }).catch((e) => {
            if (e.message === 'Network Error'){
                alert('Sorry, there is a Network error. Check your connection or try again later.')
                return;
            }
            //console.log(e.response)
            if(e.response?.status == 400){
                alert('Sorry, there is a server error: "'+e.response.statusText+'" Try again later.')
                return;
            }
            if(e.response?.status == 404) router.push('/404')
        })

    }

    const getChildResource = async (api, params) => {
        const { data } = await axios.get(api, {params: params})
        if(data.resources) return data.resources
        else
        return data
    }

    const updateResource = async (update, id) => {
        resourcePosting.value = true
        try {
            await axios.put(
                options.storePath +'/'+ id,
                update,
                { params: options.resourceParams }
            ).then((r) => {
                apiStatus.value = r.data
            })
        } catch{
            apiError.value = true
        }
        resourcePosting.value = false
    }

    const newResource = async (newResource) => {
        resourcePosting.value = true
        try {
            await axios.post(
                options.storePath,
                newResource,
                { params: options.resourceParams }
            ).then((r) => {
                resource.value = r.data
                resourceLoading.value = false
            })
        } catch{
            apiError.value = true
        }
        resourcePosting.value = false
    }

    const deleteResource = async (id) => {
        resourcePosting.value = true
        try {
            await axios.delete(
                options.resourcePath+id,
            ).then((r) => {
                apiStatus.value = r.data
            })
        } catch{
            apiError.value = true
        }
        resourcePosting.value = false
    }

    watchEffect(() => {
        getResource()
    })

    return {
        resource,
        resourceLoading,
        resourcePosting,
        getResource,
        updateResource,
        newResource,
        deleteResource,
        apiError,
        getChildResource,
        apiStatus
    }
}
